// src/pages/TeamPage.jsx - Updated with gold/accent CTA button
import React from 'react';
import { Link } from 'react-router-dom';
import TeamCard from '../components/ui/TeamCard';
import Button from '../components/ui/Button'; // Import the Button component

// Base S3 URL for your bucket
const S3_BASE_URL = 'https://amvlawwebsitefa905-dev.s3.ap-south-1.amazonaws.com';

// Team member data with direct S3 URLs for images
const teamMembers = [
  {
    id: 'mehak-gupta',
    name: 'Mehak Gupta',
    position: 'Managing Partner',
    specialization: 'Civil, Commercial & Matrimonial Litigation',
    education: 'Post graduation and Master\'s degree in Law from BVP, Pune',
    // Direct S3 URL
    image: `${S3_BASE_URL}/assets/images/team/mehak-gupta.jpeg`,
    bio: 'Adv. Mehak Gupta is a distinguished and accomplished Advocate with a stellar career spanning over a decade. Her unwavering commitment to upholding justice, coupled with her innate sense of values and passion for truth, has earned her a reputable standing in the legal fraternity.',
    contact: {
      phone: '9990358009',
      email: 'mehakgupta@amvlaw.io',
      linkedin: 'www.linkedin.com/in/mehakguptaamvlaw'
    },
    color: 'primary'
  },
  {
    id: 'vibhor-gupta',
    name: 'Vibhor Gupta',
    position: 'Managing Partner',
    specialization: 'White-Collar Crimes, Criminal Defense, Property Law',
    education: 'Alumnus of Campus Law Centre, Delhi University',
    // Direct S3 URL
    image: `${S3_BASE_URL}/assets/images/team/vibhor-gupta.jpeg`,
    bio: 'Adv. Vibhor Gupta, an alumnus of Campus Law Centre, Delhi University (CLC, DU), is a go-to litigator and strategist specializing in White-Collar Crimes, Criminal Defense, and Property Law. With expertise in trial strategy, cross-examination, and bails, he provides comprehensive legal defense for the accused in cases led by CBI, ED, SFIO, and GST authorities.',
    contact: {
      phone: '9910508654',
      email: 'vibhorgupta@amvlaw.io',
      linkedin: 'www.linkedin.com/in/vibhorguptaamvlaw'
    },
    color: 'secondary'
  },
  {
    id: 'vikas-sharma',
    name: 'Vikas Sharma',
    position: 'Legal Consultant',
    specialization: 'Customs Law, International Trade Regulations',
    education: 'Former Customs Officer',
    // Direct S3 URL
    image: `${S3_BASE_URL}/assets/images/team/vikas-sharma.jpeg`,
    bio: 'Adv. Vikas Sharma, originally from Allahabad, began his career as a Customs Officer in Mumbai, gaining firsthand insight into the complexities of customs regulations and enforcement. Driven by a passion for justice, he transitioned into law, bringing his in-depth regulatory knowledge and enforcement experience to the courtroom.',
    color: 'primary'
  },
  {
    id: 'eram-afrin',
    name: 'Eram Afrin',
    position: 'Associate',
    specialization: 'Litigation and Corporate Law',
    education: 'LL.B, Faculty of Law, Delhi University',
    // Direct S3 URL
    image: `${S3_BASE_URL}/assets/images/team/eram-afrin.jpeg`,
    bio: 'Adv. Eram Afrin is a dedicated and detail-oriented Associate at AVM Law, bringing fresh perspectives and a keen analytical approach to legal practice. As a young advocate, she is committed to mastering the intricacies of litigation and corporate law while contributing to the firm\'s dynamic legal strategies.',
    color: 'accent'
  },
  {
    id: 'akshay-dalal',
    name: 'Akshay Dalal',
    position: 'Associate',
    specialization: 'Criminal Law',
    education: 'LL.B, Symbiosis Law School',
    // Direct S3 URL
    image: `${S3_BASE_URL}/assets/images/team/akshay-dalal.jpeg`,
    bio: 'Adv. Akshay is a dynamic and detail-oriented Associate at AVM Law, with a strong focus on Criminal Law. Passionate about criminal defense and trial advocacy, he is dedicated to understanding the complexities of the legal system while ensuring justice for his clients.',
    color: 'primary'
  }
];

const TeamPage = () => {
  return (
    <div className="min-h-screen bg-white">
      {/* Hero Section */}
      <div className="bg-primary text-white py-20">
        <div className="container mx-auto px-4">
          <h1 className="text-4xl font-bold mb-4 text-center">Our Legal Team</h1>
          <p className="text-xl text-center max-w-3xl mx-auto">
            Meet our team of experienced advocates and legal professionals dedicated to your success
          </p>
        </div>
      </div>

      {/* Team Members Section */}
      <section className="py-16">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {teamMembers.map((member, index) => (
              <TeamCard
                key={member.id}
                name={member.name}
                position={member.position}
                bio={member.bio}
                image={member.image}
                color={member.color}
                index={index}
                contact={member.contact}
              />
            ))}
          </div>
        </div>
      </section>

      {/* Team Values Section */}
      <section className="py-16 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 sm:text-4xl font-serif">Our Collective Strength</h2>
            <div className="w-20 h-1 bg-secondary mx-auto my-4"></div>
            <p className="mt-4 text-xl text-gray-600 max-w-3xl mx-auto">
              We believe in collaboration, expertise, and a client-centered approach
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="bg-white p-8 rounded-lg shadow-md">
              <div className="w-12 h-12 bg-primary-50 rounded-full flex items-center justify-center mb-4">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-primary" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6V4m0 2a2 2 0 100 4m0-4a2 2 0 110 4m-6 8a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4m6 6v10m6-2a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4" />
                </svg>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Diverse Expertise</h3>
              <p className="text-gray-600">
                Our team brings together specialists from various legal domains, creating a robust knowledge base to address complex legal challenges.
              </p>
            </div>

            <div className="bg-white p-8 rounded-lg shadow-md">
              <div className="w-12 h-12 bg-secondary-50 rounded-full flex items-center justify-center mb-4">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-secondary" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                </svg>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Collaborative Approach</h3>
              <p className="text-gray-600">
                We work together across specializations, ensuring that each client benefits from our collective wisdom and diverse perspectives.
              </p>
            </div>

            <div className="bg-white p-8 rounded-lg shadow-md">
              <div className="w-12 h-12 bg-accent-50 rounded-full flex items-center justify-center mb-4">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-accent" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                </svg>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Continuous Learning</h3>
              <p className="text-gray-600">
                Our team is committed to ongoing professional development, ensuring we remain at the forefront of legal developments and innovative approaches.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Call to Action - Updated to use Gold/Accent button */}
      <section className="bg-primary py-16">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-3xl font-bold text-white mb-6">Ready to Work With Our Team?</h2>
          <p className="text-xl text-gray-300 mb-8 max-w-3xl mx-auto">
            Schedule a consultation today to discuss your legal needs with our experienced professionals.
          </p>
          
          {/* Updated to use Button component with accent (gold) variant */}
          <Button 
            href="/contact" 
            variant="accent"
            size="lg"
            className="inline-block px-8 py-3 text-lg"
          >
            Contact Us
          </Button>
        </div>
      </section>
    </div>
  );
};

export default TeamPage;